import { useEffect } from "react"
import { getAdminLoginUrl } from "../../lib/adminHost"

/** Sends public-site /login visitors to the admin subdomain. */
const RedirectToAdminLogin = () => {
  useEffect(() => {
    window.location.replace(getAdminLoginUrl())
  }, [])

  return null
}

export default RedirectToAdminLogin
